module.exports = __webpack_public_path__ + "img/xrl_xprn.30a7f5e.png";